module.exports = __webpack_public_path__ + "static/media/support40_large_banner.8e83e148.jpg";